import React from 'react';

import type { GatsbyBrowser } from 'gatsby';

import { CacheProvider } from '@emotion/react';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

import { createEmotionCache } from './src/emotion-cache';
import { RootWrapper } from './src/ui/RootWrapper';

const cache = createEmotionCache();

export const wrapRootElement: GatsbyBrowser['wrapRootElement'] = ({ element }) => {
  return (
    <CacheProvider value={cache}>
      <RootWrapper>
        <ReactQueryDevtools />
        {element}
      </RootWrapper>
    </CacheProvider>
  );
};
